const CARDS = [
  {
    img: "https://readdy.ai/api/search-image?query=Two%20actors%20sitting%20in%20a%20bright%20broadcast%20studio%20with%20warm%20lighting%2C%20interview%20setup%2C%20casual%20professional%20atmosphere%2C%20editorial%20photography%20style%2C%20table%20microphones%20and%20coffee%20cups%2C%20warm%20cream%20and%20soft%20orange%20tones%2C%20clean%20modern%20TV%20studio&width=700&height=460&seq=lian-01-2026&orientation=landscape",
    tag: "联动",
    title: "剧宣直播双人互动回放：评论区那些被“翻牌”的瞬间",
    desc: "小编逐条复盘整场直播，把两人互cue与粉丝刷屏的来龙去脉串成一条清晰的联动线。",
    time: "2小时前",
    heat: "12.4万",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Film%20production%20set%20behind%20the%20scenes%20with%20director%20chairs%20and%20camera%20equipment%2C%20documentary%20style%20crew%20movement%2C%20gray%20sky%20overhead%2C%20professional%20cinematography%20environment%2C%20warm%20editorial%20lighting%2C%20busy%20working%20atmosphere&width=700&height=460&seq=lian-02-2026&orientation=landscape",
    tag: "跨界",
    title: "双导演接力执导：幕后分工表被细扒，谁是真正的掌镜人",
    desc: "从公开花絮与访谈逐字比对，理清两位导演各自负责的篇章与剪辑归属。",
    time: "昨天 22:10",
    heat: "9.8万",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Split%20screen%20video%20call%20interface%20with%20two%20participants%2C%20one%20showing%20a%20drama%20scene%20and%20the%20other%20a%20live%20streaming%20panel%2C%20digital%20UI%20elements%2C%20editorial%20technology%20photography%2C%20modern%20content%20creator%20workspace&width=700&height=460&seq=lian-03-2026&orientation=landscape",
    tag: "串门",
    title: "老牌综艺官微连发三连cue，回归信号有多足",
    desc: "结合往季片单与嘉宾行程，推断这次“串门”是情怀彩蛋还是新季预告。",
    time: "昨天 16:40",
    heat: "7.1万",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Concert%20stage%20with%20performers%20lined%20up%20facing%20bright%20stage%20lights%2C%20audience%20silhouettes%20in%20foreground%2C%20red%20and%20gray%20lighting%2C%20energetic%20live%20performance%20atmosphere%2C%20editorial%20photography&width=700&height=460&seq=lian-04-2026&orientation=landscape",
    tag: "舞台",
    title: "剧集 OST 传主唱会登台，音乐与影视的双向奔赴",
    desc: "音综番位图流出引发讨论，我们把片方、版权方与嘉宾方的信号汇总对照。",
    time: "前天 09:12",
    heat: "6.3万",
  },
];

export default function LianSection() {
  return (
    <section id="lian" className="scroll-mt-20 bg-background-50 py-10 md:py-14">
      <div className="container-x">
        <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600">
              <span className="h-px w-6 bg-primary-400" /> CROSS-LINK
            </p>
            <h2 className="mt-2 font-display text-2xl text-foreground-900 md:text-3xl">
              联动瓜 · 跨界小料
            </h2>
          </div>
          <a
            href="#hot"
            className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm text-foreground-500 hover:text-primary-600"
          >
            更多联动追踪 <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {CARDS.map((c) => (
            <article
              key={c.title}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-100/50 transition-transform hover:-translate-y-1"
            >
              <div className="relative h-40 w-full overflow-hidden">
                <img
                  src={c.img}
                  alt={c.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 whitespace-nowrap rounded-full bg-accent-500 px-2.5 py-0.5 text-xs text-background-50">
                  {c.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="font-medium leading-snug text-foreground-900 group-hover:text-primary-600">
                  {c.title}
                </h3>
                <p className="mt-2 line-clamp-2 flex-1 text-sm text-foreground-600">{c.desc}</p>
                <div className="mt-3 flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line" /> {c.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-accent-400" /> {c.heat}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}